import React from 'react';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import cn from "classnames";
import styles from './AddressInformations.module.sass';

const AddressInformations = ({ formation, onFormationChange, loading, visible = true, onSubmit }) => {
  if (!visible) return null;

  return (
    <Card className={styles.card} title="Lieu de formation" classTitle="title-blue">
      <div className={styles.group}>
        <TextInput
          className={styles.field}
          label="Adresse"
          name="address"
          type="text"
          placeholder="Adresse complète"
          value={formation?.address || ''}
          onChange={onFormationChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Complément d'adresse"
          name="address_complement"
          type="text"
          placeholder="Ex: Bâtiment, étage..."
          value={formation?.address_complement || ''}
          onChange={onFormationChange}
        />
        <TextInput
          className={styles.field}
          label="Code Postal"
          name="zip_code"
          type="text"
          placeholder="Code postal"
          value={formation?.zip_code || ''}
          onChange={onFormationChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Ville"
          name="city"
          type="text"
          placeholder="Ville"
          value={formation?.city || ''}
          onChange={onFormationChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Pays"
          name="country"
          type="text"
          placeholder="Pays"
          value={formation?.country || ''}
          onChange={onFormationChange}
          required
        />
      </div>

    </Card>
  );
};

export default AddressInformations;
